const React = require('react');
const Gamification = require('components/Gamification');
const GamificationDiscoverControls = require('components/Gamification/DiscoverControls');
const T = require('prop-types');
const { default: Styled, css } = require('styled-components');
const LoadingScreen = require('components/LoadingScreen');
const ActiveFilterSearchBar = require('components/ActiveFilterSearchBar');
const DiscoverSearchFilterDialog = require('containers/DiscoverSearchFilterDialog');
const { default: Classes } = require('./styles.scss');
const Fonts = require('styles/fonts.json');
const SearchResultGrid = require('components/SearchResultGrid');
const { analyticsTemplates } = require('utils/analytics');
const { USERS_SORT_TYPE } = require('utils/constants');
const { default: Button } = require('@mui/material/Button');
const _capitalize = require('lodash/capitalize');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogActions } = require('@mui/material/DialogActions');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: MuiCircularProgress } = require('@mui/material/CircularProgress');
const { NavLink: Link } = require('react-router-dom');
const { default: styled } = require('styled-components');
const FocusIndicator = require('components/FocusIndicator');
const useForm = require('hooks/useForm');
const { useRouteScrollRestoration } = require('hooks/useRouteScrollRestoration');
const DiscoverPageFormConfig = require('./formConfig');

const { createRef } = React;

const SEARCH_LOADER_SIZE = 20;

const internals = {};
internals.getBooleanFilterText = (value) => {

    if (value === true || value === 'true') {
        return 'Yes';
    }

    if (value === false || value === 'false') {
        return 'No';
    }

    return null;
};

class DiscoverPage extends React.Component {

    static propTypes = {
        initLoading: T.bool,
        loading: T.bool,
        loadingNextPage: T.bool,
        interestsLoading: T.bool,
        results: T.arrayOf(T.shape({
            id: T.any.isRequired
        })),
        restoreScroll: T.func,
        rememberScroll: T.func,
        canSearchHousing: T.bool,
        hasPassionInterests: T.bool,
        discoverSortType: T.string,
        canSearchHometown: T.bool,
        showLoadMore: T.bool,
        interestsActiveFilter: T.array,
        badges: T.array,
        onClickResetSearchFilters: T.func,
        onClickLoadMore: T.func,
        onSubmitSearch: T.func,
        onClickChangeSortType: T.func,
        roleGroupFilter: T.string,
        rolePermissions: T.shape({
            id: T.number,
            name: T.string,
            label: T.string,
            schoolId: T.number,
            canViewBadge: T.bool,
            canSeeDisabledUsers: T.bool
        }),
        departments: T.arrayOf(
            T.shape({
                id: T.number,
                name: T.string
            })
        ),
        officesList: T.arrayOf(
            T.shape({
                id: T.number,
                name: T.string
            })
        ),
        yearsHiredList: T.arrayOf(
            T.shape({
                id: T.number,
                year: T.number
            })
        ),
        availableRoleGroups: T.array,
        isCompany: T.bool,
        isCommunity: T.bool,
        isSchoolOnline: T.bool,
        discoverSearchFilter: T.object,
        majors: T.arrayOf(T.shape({
            id: T.number,
            name: T.string
        })),
        setRoleGroupFilter: T.func,
        discoverNavigation: T.shape({
            currentResultIndex: T.number,
            fromDiscover: T.bool
        }),
        clearDiscoverNavigation: T.func,
        debug: T.bool
    }

    constructor(props) {

        super(props);

        this.state = {
            filtersOpen: false,
            addPassionsDialogOpen: false,
            focusAfterLoadIndex: null
        };

        this.loadMoreStartIndex = null;
        this.resultsWrapperRef = createRef();
    }

    openFilters = () => {

        analyticsTemplates.buttons('search peers', 'discover: search peers begin');
        this.setState({ filtersOpen: true });
    }

    closeFilters = () => {

        this.setState({ filtersOpen: false });
    }

    handleSortTypeChange = (newSortType) => {

        const {
            onClickChangeSortType,
            hasPassionInterests
        } = this.props;

        if (newSortType === USERS_SORT_TYPE.PASSION && !hasPassionInterests) {
            // show pop up to add passions
            this.setState({
                addPassionsDialogOpen: true
            });
        }
        else {
            onClickChangeSortType(newSortType);
        }
    }

    renderActiveFilters = () => {

        const {
            discoverSearchFilter,
            badges,
            interestsActiveFilter,
            departments,
            yearsHiredList,
            officesList,
            isCompany,
            isCommunity,
            isSchoolOnline,
            majors
        } = this.props;

        const isFilteringResults = discoverSearchFilter && !(Object.keys(discoverSearchFilter).length === 0) && !discoverSearchFilter.allByMatches;

        let interestTitle = null;

        if (interestsActiveFilter.length) {
            if (interestsActiveFilter.length === 1) {
                interestTitle = interestsActiveFilter[0].name;
            }
            else {
                interestTitle = 'Multiple Interests Chosen';
            }
        }

        let selectedBadge = null;

        if (discoverSearchFilter && discoverSearchFilter.badge) {

            const badgeItem = badges.find(({ name }) => {

                return name === discoverSearchFilter.badge;
            });

            if (badgeItem) {
                selectedBadge = badgeItem.label;
            }
        }

        let timeStatusText = null;
        if (discoverSearchFilter && discoverSearchFilter.fullTimeStatus) {

            timeStatusText = _capitalize(discoverSearchFilter.fullTimeStatus);
        }

        const isTransferText = internals.getBooleanFilterText(discoverSearchFilter?.isTransfer);
        const isOnlineText = internals.getBooleanFilterText(discoverSearchFilter?.isOnline);
        const openSocialText = internals.getBooleanFilterText(discoverSearchFilter?.openSocial);
        const veteranText = internals.getBooleanFilterText(discoverSearchFilter?.isVeteran);
        const searchIsParentText = internals.getBooleanFilterText(discoverSearchFilter?.searchIsParent);
        const workRemoteText = internals.getBooleanFilterText(discoverSearchFilter?.workRemote);

        let yearHiredText = null;
        if (discoverSearchFilter && discoverSearchFilter.yearHiredId) {

            const selectedYear = yearsHiredList.find((item) => {

                return item.id === discoverSearchFilter.yearHiredId;
            });

            if (selectedYear) {
                yearHiredText = selectedYear.year;
            }
        }

        let officeText = null;
        if (discoverSearchFilter && discoverSearchFilter.officeId) {

            const selectedOffice = officesList.find((item) => {

                return item.id === discoverSearchFilter.officeId;
            });

            if (selectedOffice) {
                officeText = selectedOffice.name;
            }
        }

        let departmentText = null;
        if (discoverSearchFilter && discoverSearchFilter.departmentId) {

            const selectedDepartment = departments.find((item) => {

                return item.id === discoverSearchFilter.departmentId;
            });

            if (selectedDepartment) {
                departmentText = selectedDepartment.name;
            }
        }

        if (isFilteringResults) {
            let firstMajor = discoverSearchFilter.major ? discoverSearchFilter.major[0] : null;

            if (firstMajor) {
                firstMajor = majors.find(({ id }) => id === firstMajor)?.name;
            }

            const activeFilters = [
                {
                    label: 'Name',
                    value: discoverSearchFilter.name ? discoverSearchFilter.name : null
                }, {
                    label: 'Age',
                    value: discoverSearchFilter.age ? discoverSearchFilter.age : null
                }, {
                    label: 'Career',
                    value: discoverSearchFilter.career ? discoverSearchFilter.career : null
                }, {
                    label: 'Profession',
                    value: discoverSearchFilter.profession ? discoverSearchFilter.profession : null
                }, {
                    label: 'Bio',
                    value: discoverSearchFilter.bio ? discoverSearchFilter.bio : null
                }, {
                    label: 'Department',
                    value: departmentText
                }, {
                    label: isCompany ? 'Affiliated Office' : 'Campus',
                    value: officeText
                }, {
                    label: 'Year Hired',
                    value: yearHiredText
                }, {
                    label: 'Work Remote',
                    value: workRemoteText
                }, {
                    label: 'Title',
                    value: discoverSearchFilter.title ? discoverSearchFilter.title : null
                }, {
                    label: 'Badge',
                    value: selectedBadge
                }, {
                    label: 'Radius',
                    value: discoverSearchFilter.radius ? discoverSearchFilter.radius : null
                }, {
                    label: 'Location',
                    value: discoverSearchFilter.locationType ?
                        (discoverSearchFilter.locationType === 'housing' ? 'Where I Live' :
                            (discoverSearchFilter.locationType === 'custom' ? discoverSearchFilter.customLocation?.name :
                                ((isCompany || isCommunity || isSchoolOnline) ? 'Where I Grew Up' : 'My Hometown'))) : null
                }, {
                    label: 'Transfer Student',
                    value: isTransferText
                }, {
                    label: 'Online Student',
                    value: isOnlineText
                }, {
                    label: 'Veteran',
                    value: veteranText
                }, {
                    label: 'Parent',
                    value: searchIsParentText
                }, {
                    label: timeStatusText,
                    value: timeStatusText,
                    labelOnly: true
                }, {
                    label: 'Incoming Class',
                    value: discoverSearchFilter.incomingClass ? discoverSearchFilter.incomingClass : null
                }, {
                    label: 'Graduating Class',
                    value: discoverSearchFilter.graduatingClass ? discoverSearchFilter.graduatingClass : null
                }, {
                    label: 'Major',
                    value: firstMajor || null
                }, {
                    label: 'Student Name',
                    value: discoverSearchFilter.studentName ? discoverSearchFilter.studentName : null
                }, {
                    label: 'Interests',
                    value: interestTitle
                }
            ];

            return activeFilters;
        }

        return [];
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (!nextProps.loadingNextPage && this.props.loadingNextPage) {
            FocusIndicator.onBlurHandler();

            if (this.loadMoreStartIndex !== null) {
                this.setState({ focusAfterLoadIndex: this.loadMoreStartIndex });
                this.loadMoreStartIndex = null;
            }
        }
    }

    handleLoadMore = () => {

        this.loadMoreStartIndex = this.props.results.length;
        this.setState({ focusAfterLoadIndex: null });
        this.props.onClickLoadMore();
    }

    render() {

        const { filtersOpen } = this.state;

        const {
            initLoading,
            loading,
            loadingNextPage,
            interestsLoading,
            results,
            canSearchHousing,
            canSearchHometown,
            onSubmitSearch,
            discoverSearchFilter,
            rolePermissions: { canSeeDisabledUsers },
            discoverSortType,
            showLoadMore,
            roleGroupFilter,
            availableRoleGroups,
            setRoleGroupFilter,
            debug
        } = this.props;

        const {
            styles,
            Wrapper,
            ResultsWrapper,
            CircularProgress,
            DiscoverHeaderControlsForm,
            RouteScrollRestoration,
            PageTitle
        } = internals;

        const isFilteringResults = discoverSearchFilter
            && !(Object.keys(discoverSearchFilter).length === 0)
            && !discoverSearchFilter.allByMatches;
        const activeFilters = this.renderActiveFilters();
        const hasVisibleActiveFilters = activeFilters.some(({ value }) => (
            value !== undefined && value !== null && value !== false
        ));

        return <Wrapper>
            <RouteScrollRestoration
                rememberScroll={this.props.rememberScroll}
                restoreScroll={this.props.restoreScroll}
                shouldRestore={!this.props.discoverNavigation?.fromDiscover}
            />
            <Gamification mode='discover' onWeeklyLeadersChange={(weeklyLeaderRanks) => this.setState({ weeklyLeaderRanks })} onViewChange={(showLeaderboard) => this.setState({ showLeaderboard })} renderDiscoverControls={(gamification) => <DiscoverHeaderControlsForm
                gamification={gamification}
                availableRoleGroups={availableRoleGroups}
                canSearchHometown={canSearchHometown}
                canSearchHousing={canSearchHousing}
                canSeeDisabledUsers={canSeeDisabledUsers}
                discoverSortType={discoverSortType}
                roleGroupFilter={roleGroupFilter}
                setRoleGroupFilter={setRoleGroupFilter}
                onSortChange={this.handleSortTypeChange}
            />} />
            {!this.state.showLeaderboard && <>

            <div style={internals.styles.searchContainer}>
                <ActiveFilterSearchBar
                    activeFilters={activeFilters}
                    isFilteringResults={isFilteringResults && hasVisibleActiveFilters}
                    onOpenFilters={this.openFilters}
                    onClearFilters={() => {

                        this.props.onClickResetSearchFilters(discoverSortType);
                        FocusIndicator.onBlurHandler();
                    }}
                />
            </div>
            <PageTitle>Find Your People</PageTitle>
            {!filtersOpen && <div className={`${Classes.main} ${Classes.noPaddingMain}`}>
                {(!!initLoading || !!loading || !!interestsLoading) && (
                    <internals.DiscoverLoaderWrapper>
                        <LoadingScreen variant='content' />
                    </internals.DiscoverLoaderWrapper>
                )}
                <div>
                    {!loading && (!results || !results.length) && <div className={Classes.noResults}>No peers found</div>}
                    {results && !loading && <ResultsWrapper ref={this.resultsWrapperRef}>
                        <SearchResultGrid
                            weeklyLeaderRanks={this.state.weeklyLeaderRanks}
                            results={results}
                            showConnectionStatus={discoverSortType === USERS_SORT_TYPE.CONNECTION_STATUS}
                            showDistance={discoverSortType === USERS_SORT_TYPE.HOMETOWN || discoverSortType === USERS_SORT_TYPE.HOUSING || !!(discoverSearchFilter?.locationType && discoverSearchFilter?.radius)}
                            scrollToIndex={this.props.discoverNavigation?.fromDiscover ? this.props.discoverNavigation?.currentResultIndex : undefined}
                            onScrollComplete={this.props.discoverNavigation?.fromDiscover ? this.props.clearDiscoverNavigation : undefined}
                            focusIndex={this.state.focusAfterLoadIndex}
                            isFromDiscover
                            debug={debug}
                        />
                    </ResultsWrapper>}
                </div>
            </div>}
            {!!showLoadMore && !loading &&
                <Button
                    // Yeah these are inline styles, we'll copy paste them for the upgrade branch
                    style={{ ...styles.button, margin: '0 32px 32px 32px' }}
                    variant='contained'
                    color='primary'
                    onClick={this.handleLoadMore}
                    data-focus-outline='radius:40,padding:-1'
                >
                    Load More Results {loadingNextPage && <CircularProgress color='secondary' size={SEARCH_LOADER_SIZE} />}
                </Button>
            }

            <Dialog
                open={this.state.addPassionsDialogOpen}
                onClose={() => {

                    this.setState({
                        addPassionsDialogOpen: false
                    });
                }}
                aria-labelledby="alert-add-passions"
                aria-describedby="alert-add-passions-description"
            >
                <DialogTitle id="alert-add-passions-title">{'Add Passion Interests'}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-Inappropriate-Message-description">
                        To match with others who share your passions, first <Link
                            to={{
                                pathname: '/app/profile/edit/interests',
                                state: {
                                    scrollToInterests: true
                                }
                            }}>edit your profile</Link> to designate up to 5 of your Interests as Passions.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {

                        this.setState({
                            addPassionsDialogOpen: false
                        });
                    }} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <DiscoverSearchFilterDialog
                open={filtersOpen}
                onSubmit={onSubmitSearch}
                onRequestClose={this.closeFilters}
                canSearchHousing={canSearchHousing}
                canSearchHometown={canSearchHometown}
                isBlankSearch={!isFilteringResults}
            />
            </>}
        </Wrapper>;
    }
}

module.exports = DiscoverPage;
module.exports.internals = internals;

internals.noop = () => {};

internals.RouteScrollRestoration = function RouteScrollRestoration(props) {

    useRouteScrollRestoration(props);

    return null;
};

internals.RouteScrollRestoration.propTypes = {
    rememberScroll: T.func.isRequired,
    restoreScroll: T.func.isRequired,
    shouldRestore: T.bool
};

internals.DiscoverHeaderControlsForm = function DiscoverHeaderControlsForm(props) {

    const {
        availableRoleGroups,
        canSearchHometown,
        canSearchHousing,
        canSeeDisabledUsers,
        discoverSortType,
        roleGroupFilter,
        setRoleGroupFilter,
        onSortChange,
        gamification
    } = props;

    const formConfig = DiscoverPageFormConfig.buildFormConfig({
        availableRoleGroups,
        gamification,
        canSearchHometown,
        canSearchHousing,
        canSeeDisabledUsers,
        discoverSortType,
        filterFieldStyles: internals.filterFieldStyles,
        onSubmit: internals.noop,
        onSortChange,
        roleGroupFilter,
        setRoleGroupFilter
    });

    const { Form } = useForm(formConfig);

    const roleLabel = availableRoleGroups?.find(({ name }) => name === 'student')?.label || 'Students';

    return <internals.DiscoverHeaderControlsFormWrapper $compact={gamification?.enabled}>
        <GamificationDiscoverControls {...gamification} normalControls={Form} roleLabel={roleLabel} />
    </internals.DiscoverHeaderControlsFormWrapper>;
};

internals.DiscoverHeaderControlsForm.propTypes = {
    availableRoleGroups: T.array,
    canSearchHometown: T.bool,
    canSearchHousing: T.bool,
    canSeeDisabledUsers: T.bool,
    discoverSortType: T.string,
    roleGroupFilter: T.string,
    setRoleGroupFilter: T.func.isRequired,
    onSortChange: T.func.isRequired
};

internals.styles = {
    searchContainer: {
        padding: '0 20px',
        width: '100%',
        margin: '0 auto'
    },
    button: {
        minWidth: '50%',
        display: 'inline-block',
        lineHeight: '34px' // Adjust for border
    },
    buttonLabel: {
        fontFamily: Fonts.headerFont,
        fontWeight: 'bold',
        textTransform: 'none',
        letterSpacing: 1
    }
};

internals.PageTitle = Styled.h1`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    width: fit-content;
    margin: 16px auto 16px !important;
    padding: 0 12px;
    border-radius: 999px;
    background: rgba(18, 39, 79, 0.06);
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 18px;
    line-height: 22px;
    font-weight: 800;
    letter-spacing: -0.015em;
    text-align: center;

    @media screen and (max-width: 600px) {
        margin: 2px auto 16px !important;
    }
`;

internals.Wrapper = Styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

internals.ResultsWrapper = Styled.div`
    margin-top: -8px;

    ul {
        margin-top: 0;
    }
`;

internals.DiscoverLoaderWrapper = Styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 320px;
    width: 100%;
`;

internals.CircularProgress = Styled(MuiCircularProgress)`
    position: absolute;
    width: ${SEARCH_LOADER_SIZE}px;
    height: ${SEARCH_LOADER_SIZE}px;
    top: 12px;
    margin-left: 12px;
`;

internals.DiscoverHeaderControlsFormWrapper = Styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 20px 20px 0;
    background: white;
    display: flex;
    justify-content: center;

    form {
        max-width: 560px;
        align-items: center;
        gap: 0;
    }

    form > div:first-child {
        width: 100%;
        display: flex !important;
        flex-flow: row nowrap !important;
        align-items: center;
        justify-content: center;
        gap: 12px !important;
    }

    form > div:first-child > * {
        flex: 0 0 150px;
        max-width: 150px;
    }

    ${(props) => props.$compact && css`
        form > div:first-child > * { flex: 1 1 0; min-width: 0; max-width: none; }
        .MuiFormControl-root { min-width: 0 !important; width: 100% !important; }
    `}

    @media screen and (max-width: 430px) {
        form > div:first-child {
            gap: 8px !important;
        }
    }
`;

internals.filterFieldStyles = css`
    &.MuiFormControl-root {
        width: 150px;
        min-width: 150px;
        padding: 0 !important;
    }

    .MuiFilledInput-root {
        height: 48px;
        border-radius: 10px;
        background: rgba(18, 39, 79, 0.06);
        overflow: hidden;

        &:before,
        &:after,
        &:hover:not(.Mui-disabled):before {
            display: none;
        }

        &:hover,
        &.Mui-focused {
            background: rgba(18, 39, 79, 0.08);
        }
    }

    label.MuiInputLabel-root {
        max-width: calc(100% - 24px);
        margin-top: 0 !important;
        height: 16px !important;
        line-height: 16px !important;
        color: rgba(18, 39, 79, 0.56);
        font-size: 12px;
        transform: translate(12px, 5px) scale(1) !important;
        pointer-events: none;
    }

    .MuiInputLabel-shrink {
        transform: translate(12px, 5px) scale(1) !important;
    }

    .MuiSelect-select.MuiFilledInput-input {
        min-height: 20px;
        padding: 22px 32px 6px 12px !important;
        background: transparent;
        color: ${({ theme }) => theme.palette.text.primary};
        font-size: 16px;
        line-height: 20px;
    }

    .MuiSvgIcon-root {
        right: 8px;
        color: rgba(18, 39, 79, 0.56);
    }
`;
